import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function AddDialog(props) {
    const { onSave, onClose, open } = props;

    const [vendorId, setVendorId] = React.useState("");
    const [vendorName, setVendorName] = React.useState("");
    const [locationName, setLocationName] = React.useState("");
    const [locationLat, setLocationLat] = React.useState("");
    const [locationLng, setLocationLng] = React.useState("");
    const [truckRate, setTruckRate] = React.useState("");
    const [tripperRate, setTripperRate] = React.useState("");
    const [tractorRate, setTractorRate] = React.useState("");

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            "vendor_id": vendorId,
            "name": vendorName,
            location: {
                name: locationName,
                lat: parseFloat(locationLat),
                lng: parseFloat(locationLng)
            },
            "rate": {
                "truck": parseFloat(truckRate),
                "tripper": parseFloat(tripperRate),
                "tractor": parseFloat(tractorRate)
            }
        });
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{`Add new vendor`}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <div>
                    <div>
                        <TextField
                            id="vendor-id"
                            label="Vendor Id"
                            value={vendorId}
                            onChange={(e) => setVendorId(e.target.value)}
                        />
                        <TextField
                            id="vendor-name"
                            label="Vendor Name"
                            value={vendorName}
                            onChange={(e) => setVendorName(e.target.value)}
                        />
                    </div>
                    <div>
                        <TextField
                            id="location-name"
                            label="Location Name"
                            value={locationName}
                            onChange={(e) => setLocationName(e.target.value)}
                        />
                    </div>
                    <div>
                        <TextField
                            id="location-lat"
                            label="Location Latitude"
                            value={locationLat}
                            onChange={(e) => setLocationLat(e.target.value)}
                        />
                        <TextField
                            id="location-lng"
                            label="Location Longitude"
                            value={locationLng}
                            onChange={(e) => setLocationLng(e.target.value)}
                        />
                    </div>
                    <div>
                        <TextField
                            id="truck-rate"
                            label="Truck Rate"
                            type="number"
                            value={truckRate}
                            onChange={(e) => setTruckRate(e.target.value)}
                        />
                        <TextField
                            id="tripper-rate"
                            label="Tripper Rate"
                            type="number"
                            value={tripperRate}
                            onChange={(e) => setTripperRate(e.target.value)}
                        />
                        <TextField
                            id="tractor-rate"
                            label="Tractor Rate"
                            type="number"
                            value={tractorRate}
                            onChange={(e) => setTractorRate(e.target.value)}
                        />
                    </div>
                    <div style={{ margin: '10px', float: 'right' }}>
                        <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                        <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                    </div>
                </div>
            </Box>
        </Dialog>
    );
}
